export default function initOpenClose() {
  document.querySelectorAll('.dropdown-holder').forEach(holder => {
    const btnMenu = holder.querySelector('.opener');
    const drop = holder.querySelector('.dropdown');
    const openedClass = 'opened';

    if(!btnMenu) return;

    const openCloseMenu = (e) => {
      e.preventDefault();
      holder.classList.toggle(openedClass);
    };

    btnMenu.addEventListener('click', openCloseMenu);

    document.addEventListener('click', (event) => {
      if (!holder.contains(event.target) && !event.target.classList.contains(drop)) {
        holder.classList.remove(openedClass);
      }
    });
  });

  document.querySelectorAll('.actions').forEach(holder => {
    const btnMenu = holder.querySelector('.actions-toggler');
    const drop = holder.querySelector('.drop');
    const openedClass = 'opened';

    if(!btnMenu) return;

    const openCloseMenu = (e) => {
      e.preventDefault();
      holder.classList.toggle(openedClass);
    };

    btnMenu.addEventListener('click', openCloseMenu);

    document.addEventListener('click', (event) => {
      if (!holder.contains(event.target) && !event.target.classList.contains(drop)) {
        holder.classList.remove(openedClass);
      }
    });
  });
}
